/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Faq_Q4Inputs */

const en_to_yaml_faq_q4 = /** @type {(inputs: To_Yaml_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I convert YAML back to JSON?`)
};

const ko_to_yaml_faq_q4 = /** @type {(inputs: To_Yaml_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML을 다시 JSON으로 변환할 수 있나요?`)
};

const ja_to_yaml_faq_q4 = /** @type {(inputs: To_Yaml_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAMLからJSONに逆変換できますか？`)
};

/**
* | output |
* | --- |
* | "Can I convert YAML back to JSON?" |
*
* @param {To_Yaml_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_faq_q4 = /** @type {((inputs?: To_Yaml_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_faq_q4(inputs)
	if (locale === "ko") return ko_to_yaml_faq_q4(inputs)
	return ja_to_yaml_faq_q4(inputs)
});